import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nskhtecdp8: FaireBrandEntity = {
  token: "b_nskhtecdp8",
  type: "brand",
  name: "Serafine Art and Design",
  avatarUrl:
    "https://cdn.faire.com/fastly/fd95a9c2a79d211c18ebfbf506822d3498b1640fddec399b07b06b85c9e4b52c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/06ae815891dca112f1bdba5c5ce0d399475f28cc54c1fa238c6b265a5d7b33e8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fd95a9c2a79d211c18ebfbf506822d3498b1640fddec399b07b06b85c9e4b52c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/06ae815891dca112f1bdba5c5ce0d399475f28cc54c1fa238c6b265a5d7b33e8.png",
  location: "Akron, OH, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "Serafine Art and Design creates cozy coloring books and stationery for romance readers, fantasy lovers, and whimsical book fairies. Each coloring book features bold, easy-to-color designs that keep the magic of bookishness alive — perfect for unwinding with your favorite audiobook and a cup of tea.\n\nEvery design is hand-illustrated (absolutely NO AI!) with love. \n\nOwner and artist, Marie Lipocky, lives in Massillon OH with her husband and two young boys. In her spare time, she loves reading romantasy, collecting plants, and drinking loose leaf tea. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:45.748Z",
    importedBy: "entity-db-cli",
  },
};
